import Vue from 'vue';

export default {
  state: {
    customerItems: [],
  },
  getters: {
    CUSTOMER_ITEMS: state => {
      return state.customerItems;
    },
    CUSTOMER_ALBUMS: state => {
      return state.customerItems;
    },
  },
  mutations: {
    SET_CUSTOMER_ITEMS: (state, payload) => {
      state.customerItems = payload;
    },
    ADD_CUSTOMER_ITEM: (state, payload) => {
      state.customerItems.push(payload);
    },
  },
  actions: {
    INIT_CUSTOMER_ITEMS: async (context, sync = false) => {
      if (sync) {
        const syncPrivateAlbumsData = JSON.parse(
            localStorage.getItem('syncPrivateAlbumsData'));

        if (syncPrivateAlbumsData && syncPrivateAlbumsData.length > 0) {
          await Vue.axios.post('customers/add_private_albums',
              {album_ids: syncPrivateAlbumsData});
          localStorage.removeItem('syncPrivateAlbumsData');
        }
      }

      if (context.getters.USER) {
        try {
          const response = await Vue.axios.get(
              'albums/get_customer_albums');

          if (response.data.success) {
            const customerItems = [];

            response.data.data.forEach(item => {
              if (item.albums) {
                item.albums.forEach(album => {
                  album.tag_name = item.tag_name;
                  album.tag_url = `${item.tag_hash}-${item.tag_pw}`;
                  customerItems.push(album);
                });
              } else {
                customerItems.push(item);
              }
            });

            if (customerItems && customerItems.length > 0) {
              context.commit('SET_CUSTOMER_ITEMS', customerItems);
              localStorage.setItem('customerItems',
                  JSON.stringify(customerItems));
            }
          }
        } catch (e) {
          // eslint-disable-next-line no-console
          console.log(e);
        }
      } else {
        const customerItems = JSON.parse(
            localStorage.getItem('customerItems'));

        if (customerItems && customerItems.length > 0) {
          context.commit('SET_CUSTOMER_ITEMS', customerItems);
        }
      }
    },
    ADD_CUSTOMER_ITEM: async (context, item) => {
      context.commit('ADD_CUSTOMER_ITEM', item);
      localStorage.setItem('customerItems',
          JSON.stringify(context.getters.CUSTOMER_ITEMS));
    },
  },
};